
// Libraries
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component({})
export default class DailySvgChart extends Vue {
  @Prop() dateObject: { dd: string; mm: string; yyyy: string; mmmm: string };

  get imagePath() {
    return `${process.env.PARTNER_MEDIA_CDN}/chart/screenshot/heizoelpreise-3-${this.dateObject.yyyy}-${this.dateObject.mm}-${this.dateObject.dd}.jpg`;
  }
}
